import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import ClientSideConfigSelector from '../../../../recoil/cashout/ClientSideConfigSelector';
import { getFormattedCurrency, getFormattedPrice, getProductFormattedNumber } from '../../../helpers/CurrencyUtils';

export default function CashoutAwards({ awards }) {
  const { t } = useTranslation(null, { useSuspense: false });

  const config = useRecoilValue(ClientSideConfigSelector);
  const {
    live: {
      claimReward: {
        appCurrency,
        categories: {
          conversion: conversionCurrency,
        },
      } = {},
    },
  } = config;

  const occurrenceMap = {};

  return (
    <>
      {awards.map((award, idx) => {
        const currency = award.currency?.toUpperCase();
        const key = `${currency || ''}-${award.amount}`;

        const currentCount = occurrenceMap[key] || 0;
        occurrenceMap[key] = currentCount + 1;

        const compositeKey = `${key}-${currentCount}`;

        if (currency === conversionCurrency.toUpperCase()) {
          return (
            <React.Fragment key={compositeKey}>
              {idx > 0 ? <span className="cashout-award-separator"> + </span> : null}
              <span className="cashout-award-item">
                <span>
                  {`${getProductFormattedNumber(award.amount)} ${t(getFormattedCurrency(award.currency, appCurrency))}`}
                </span>
              </span>
            </React.Fragment>
          );
        }

        return (
          <React.Fragment key={compositeKey}>
            {idx > 0 ? <span className="cashout-award-separator"> + </span> : null}
            <span className="cashout-award-item">
              {getFormattedPrice(award.amount, award.currency)}
            </span>
          </React.Fragment>
        );
      })}
    </>
  );
}

CashoutAwards.propTypes = {
  awards: PropTypes.arrayOf(PropTypes.shape({
    currency: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
};

CashoutAwards.defaultProps = {
  awards: [],
};
